<div class="access-denied-container">
	<div class="access-denied-top">
		<div class="left-side">
			<img src="assets/images/Tecnalia_Logo.jpg" draggable="false" alt="Tecnalia Logo">
		</div>
		<div class="right-side">
			<form id="access-denied-body">
				<div class="title-1 access-denied-title">
					Access denied
				</div>
				<div class="error-msg">
					You do not have access to the desired page.
				</div>
				<div class="error-msg">
					Please log in with different credentials or contact the IT department.
				</div>
				<a class="login-link" role="button" (click)="login()">
					Log in with different credentials
				</a>
			</form>
		</div>
	</div>
	<div class="title-4 access-denied-footer">
		2026 © Tecnalia Research & Innovation
	</div>
</div>